import Angular from "angular";
import Template from "./calendar-item.html";
import Controller from "./calendar-item.controller.js";

let CalendarItemModule = Angular.module('calendar-item', [])

    .component('calendarItem', {
        template: Template,
        controller: Controller,
        transclude: true,
        scope: true,
        bindings: {
            item: "<",
            layout: "<",
            zoom: "<"
        }
    });

export default CalendarItemModule;



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/calendar-item.js